import React from "react";
import "./Tauchen.css";

export default function Tauchen() {
  return (
    <main className="tauchen-container">
      <h1>Tauchen bei DiverDuck</h1>

      <section id="intro">
        <p>
          Tauchen ist mehr als nur ein Sport – es ist ein Abenteuer, eine
          Leidenschaft und ein Zugang zu einer faszinierenden Unterwasserwelt.
          Bei DiverDuck Berlin e.V. begleiten wir Dich auf Deinem Weg in diese
          Welt – egal ob du gerade erst beginnst oder bereits Erfahrung hast.
        </p>
      </section>

      <section>
        <h2>Für Einsteiger:innen</h2>
        <p>
          Du möchtest erste Erfahrungen unter Wasser sammeln? In unseren
          Schnupperkursen und der Grundausbildung vermitteln wir Dir alles
          Wichtige über Tauchtechnik, Sicherheit, Ausrüstung und das Verhalten
          unter Wasser – praxisnah und mit viel Freude.
        </p>
      </section>

      <section>
        <h2>Für Fortgeschrittene</h2>
        <p>
          Fortgeschrittene Taucher:innen finden bei uns die Möglichkeit, ihre
          Fähigkeiten weiter auszubauen – etwa durch Aufbautrainings,
          Spezialbrevets oder gemeinsame Tauchgänge in Binnengewässern und bei
          Vereinsausfahrten.
        </p>
      </section>

      <section>
        <h2>Ausbildung & Sicherheit</h2>
        <p>
          Unsere Ausbilder:innen sind nach den Richtlinien des VDST (Verband
          Deutscher Sporttaucher) und CMAS (Confédération Mondiale des Activités
          Subaquatiques) zertifiziert. Sicherheit steht bei uns an oberster
          Stelle – daher legen wir besonderen Wert auf qualitativ hochwertige
          Ausbildung und individuelle Betreuung.
        </p>
      </section>

      <section>
        <h2>Tauchausfahrten & Events</h2>
        <p>
          Neben dem regelmäßigen Training bieten wir auch Tauchausflüge zu Seen
          in der Umgebung oder gemeinsame Vereinsausfahrten an – ideal, um das
          Gelernte anzuwenden, Natur zu genießen und als Gruppe unvergessliche
          Momente unter Wasser zu erleben.
        </p>
      </section>

      <section id="ausbildung">
        <h2>Tauchausbildung</h2>
        <p>
          Unsere Tauchausbildung erfolgt nach den Vorgaben des VDST / CMAS. Da
          wir ein kleiner Verein sind, findet die Ausbildung bei uns nur auf
          Anfrage statt. Das bietet Dir den Vorteil, dass wir ganz individuell
          auf Deine Bedürfnisse eingehen können – in der Regel als persönliche
          Eins-zu-eins-Ausbildung.
        </p>
        <p>
          Du wirst bei uns nicht unter Zeitdruck gesetzt: Unsere ehrenamtlichen
          Tauchlehrer begleiten Dich in Deinem Tempo. Für die Ausbildung
          veranschlagen wir lediglich die entstehenden Selbstkosten. Eine
          Mitgliedschaft ist dabei <strong>nicht zwingend erforderlich</strong>.
        </p>

        <p style={{ marginTop: "1rem" }}>Ansprechpartner für die Ausbildung:</p>
        <ul>
          <li>
            <strong>Martin</strong> – 2-Stern-Tauchlehrer
          </li>
          <li>
            <strong>Jacqueline</strong> – 1-Stern-Tauchlehrerin
          </li>
        </ul>
      </section>

      <section id="ausflug">
        <h2>Vereinsausflug zum Gröberner See(Sachsen-Anhalt)</h2>
        <p>
          Wir versuchen mindestens einmal im Jahr ein gemeinsames
          Tauchwochenende zu organisieren. Zuletzt waren wir im Sommer 2023 am
          Gröberner See bei Leipzig. Acht Vereinsmitglieder nahmen daran teil –
          für zwei davon stand das praktische CMAS-Bronze-Brevet auf dem
          Programm, das sie erfolgreich abschließen konnten.
        </p>
      </section>

      <section id="schnuppertauchen">
        <h2>Schnuppertauchen</h2>

        <h3>Was ist Schnuppertauchen?</h3>
        <p>
          Beim Schnuppertauchen hast Du die Gelegenheit, unter Anleitung eines
          Tauchlehrers und mit vollständiger Ausrüstung das Gerätetauchen
          auszuprobieren. Die Tauchtiefe ist auf 2 Meter begrenzt und das Ganze
          findet im Schwimmbad statt. Das Mindestalter für die Teilnahme beträgt
          10 Jahre.
        </p>

        <p>
          Wichtig ist, dass Du zum Zeitpunkt des Schnuppertauchens nicht
          erkältet bist und Dich körperlich fit fühlst.
        </p>

        <h3>Kosten & Ablauf</h3>
        <p>
          Das Schnuppertauchen ist bei uns <strong>kostenfrei</strong> und wird
          jeden Mittwoch - nach vorheriger Anmeldung - während unserer regulären
          Trainingszeiten im Prinzenbad oder nach individueller Absprache
          angeboten.
        </p>

        <h3>Anmeldung</h3>
        <p>
          Melde Dich einfach über unser <a href="/kontakt">Kontaktformular</a>{" "}
          oder per E-Mail an. Gib bitte an, ob Du eigene Ausrüstung (Maske,
          Schnorchel, Flossen) besitzt oder ob Du eine Leih-ABC-Ausrüstung
          benötigst – wir stellen Dir diese gerne zur Verfügung. Ebenfalls sind
          Badelatschen sehr vorteilhaft.
        </p>
      </section>
    </main>
  );
}
